import { labelStyleNorlys } from '~src/branding/input';
import { Label } from '~src/components/Label';

import { FormElementWrapperProps } from '../types';
import { WrapperNorlys } from './style';

export const FormElementWrapperNorlys = ({
  label,
  attention,
  size = 'middle',
  style,
  children,
}: FormElementWrapperProps) => {
  return (
    <WrapperNorlys {...{ attention, size, style }}>
      {label && <Label {...{ style: labelStyleNorlys() }}>{label}</Label>}
      {children}
    </WrapperNorlys>
  );
};
